import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = { class: "filter-form" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("开通应用")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("进入后台")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("管理报表")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("已配置")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 未配置 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_divider = _resolveComponent("a-divider")
  const _component_a_table = _resolveComponent("a-table")
  const _component_add = _resolveComponent("add")
  const _component_opening = _resolveComponent("opening")
  const _component_config = _resolveComponent("config")
  const _component_dashboard = _resolveComponent("dashboard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, {
        model: _ctx.filter,
        layout: "inline",
        labelAlign: "right",
        scrollToFirstError: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "",
            name: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_search, {
                value: _ctx.filter.name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.name = $event)),
                valueModifiers: { trim: true },
                placeholder: "请输入企业名称",
                "allow-clear": true,
                onSearch: _ctx.refresh
              }, null, 8, ["value", "onSearch"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.filter.type,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.type = $event)),
                placeholder: "企业付费状态",
                onChange: _ctx.refresh,
                allowClear: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.accountTypeOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.filter.status,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.status = $event)),
                onChange: _ctx.refresh,
                placeholder: "商户状态：请选择",
                allowClear: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createVNode(_component_a_table, {
      scroll: _ctx.scroll,
      "data-source": _ctx.data,
      columns: _ctx.columns,
      loading: _ctx.loading,
      pagination: _ctx.pagination,
      ref: "tableElRef",
      onChange: _ctx.handleTableChange,
      "row-key": (record) => record.corpId
    }, {
      applyTime: _withCtx(({ text: applyTime }) => [
        _createVNode("div", null, _toDisplayString(applyTime), 1)
      ]),
      isOpenConversation: _withCtx(({ record }) => [
        _createVNode("div", null, _toDisplayString(record.isOpenConversation ? '是' : '否'), 1)
      ]),
      versionId: _withCtx(({ record }) => [
        _createVNode("div", null, _toDisplayString(record.versionId === 1 ? '普通版' : '百家云版'), 1)
      ]),
      type: _withCtx(({ record }) => [
        _createVNode("div", null, _toDisplayString(record.type === 1 ? '试用版' : '付费版'), 1)
      ]),
      smsPrice: _withCtx(({ record }) => [
        _createVNode("div", null, _toDisplayString(record.smsPrice ? _ctx.divide(record.smsPrice, 100) : '--'), 1)
      ]),
      signature: _withCtx(({ record }) => [
        _createVNode("div", null, _toDisplayString(record?.signature?.length ? record.signature.join('、') : '--'), 1)
      ]),
      expireDate: _withCtx(({ record }) => [
        _createVNode("div", null, _toDisplayString(_ctx.formatDate(record.expireDate, 'YYYY-MM-DD')), 1)
      ]),
      appNames: _withCtx(({ record }) => [
        _createVNode("div", null, [
          (record.appNames != null)
            ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(record.appNames.join('/')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      status: _withCtx(({ record }) => [
        _createVNode("div", null, [
          (record.status === 3)
            ? (_openBlock(), _createBlock("span", _hoisted_4, "过期"))
            : _createCommentVNode("", true),
          (record.status === 2)
            ? (_openBlock(), _createBlock("span", _hoisted_5, "禁用"))
            : _createCommentVNode("", true),
          (record.status === 1)
            ? (_openBlock(), _createBlock("span", _hoisted_6, "正常"))
            : _createCommentVNode("", true)
        ])
      ]),
      action: _withCtx(({ record }) => [
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.enableAction(record))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(record.status === 1 ? '禁用' : '启用'), 1)
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_a_divider, { type: "vertical" }),
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.modAction(record))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_a_divider, { type: "vertical" }),
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.ApplicationOpen(record))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_a_divider, { type: "vertical" }),
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.mock(record))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_a_divider, { type: "vertical" }),
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.setDashbroadPage(record))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      customizedConfig: _withCtx(({ record }) => [
        (record?.customizedConfig?.devStatus === -1)
          ? (_openBlock(), _createBlock("span", _hoisted_11, "未授权"))
          : _createCommentVNode("", true),
        (record?.customizedConfig?.devStatus === 2)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "link",
              onClick: ($event: any) => (_ctx.openConfig(record))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true),
        (record?.customizedConfig?.devStatus === 0 || record?.customizedConfig?.devStatus === 1)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              type: "link",
              onClick: ($event: any) => (_ctx.openConfig(record))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["scroll", "data-source", "columns", "loading", "pagination", "onChange", "row-key"]),
    (_ctx.store.state.business.addState)
      ? (_openBlock(), _createBlock(_component_add, {
          key: 0,
          onSuccess: _ctx.fetchList
        }, null, 8, ["onSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.store.state.business.applicationstate)
      ? (_openBlock(), _createBlock(_component_opening, {
          key: 1,
          onSuccess: _ctx.fetchList
        }, null, 8, ["onSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.configState.visible)
      ? (_openBlock(), _createBlock(_component_config, {
          key: 2,
          value: _ctx.configState.value,
          sassId: _ctx.configState.id,
          onClose: _ctx.closeConfig
        }, null, 8, ["value", "sassId", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.dashboardState.visible)
      ? (_openBlock(), _createBlock(_component_dashboard, {
          key: 3,
          value: _ctx.dashboardState.value,
          onClose: _ctx.closeDashboard
        }, null, 8, ["value", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}